"use client"
import Alert from "@/components/Atoms/Alerts/Alert";
import { ArrowUpButton, CommentButton, IndigoButton, OpenUrlButton, TealButton, TrashButton } from "@/components/Atoms/Buttons/ColorButtons";
import ReactMarkdownMod from "@/components/Atoms/ReactMarkdownMod";
import TagPill_1 from "@/components/Atoms/Tags/TagPill_1";
import AvatarImage from "@/components/Molecules/AvatarImage";
import { dateFormat_2, dateFormat_3 } from "@/utils/frontend/dateOps";
import getTagDevIconName from "@/utils/frontend/getTagDevIconName";
import { formatSocialPostBody, formatString, getEntityLocationStr, humanizeString } from "@/utils/frontend/stringOps";
import Link from "next/link";
import { useState } from "react";
import ReactMarkdown from 'react-markdown';
import { useRouter, useSearchParams } from 'next/navigation'
import BorderedFrameBox from "@/components/Molecules/BorderedFrameBox";

import { UIContext } from "@/contexts/UIContext";
import { useContext } from "react";


/*----------------------------------------------------------------
     This card closely mimics SocialPostSmallCard.js (latter came first)
----------------------------------------------------------------*/
const NotificationSmallCard = ({ 
  data, 
  callback, 
  lang, 
  user, 
  parentComponent, // INDEX, THREAD
  isNestedComment, 
  replyToUUID }) => {

       const { supportModalOpen, setSupportModalOpen, sideNavbarPinned, setSideNavbarPinned, success, setSuccess, error, setError, setNotificationsModalOpen } = useContext(UIContext);

  // console.log('data@socialpostmsallcard', data)
// console.log(data.parent_social_post_comment_uuid, data.social_post_comment_body)
  const router = useRouter()
  const searchParams = useSearchParams()
//   const [success, setSuccess] = useState(false)
//   const [error, setError] = useState(false)
  const [deleteConfirmation, setDeleteConfirmation] = useState(0)
  const [rootDeleteConfirmation, setRootDeleteConfirmation] = useState(0)
  // console.log("DATA@SocialPostSmallCard.js", data)
  // console.log("DATA@JobBigCard.js", data)
  // let data = selectedData ? selectedData : initialData 



    //callback from TasksSplitViewCard.js 
    // handleSubmit from Task Status Button
    const handleChildCallback= async (cback)=> {
       
    }   

    // console.log("DATA@JobBigCard", data)

    const handleEditSubmit = (element) =>{

        const putData = {
            id: data?.task_data.id,
            task_title: editedData?.task_title || data?.task_data.task_title,
            task_type: editedData?.task_type || data?.task_data.task_type,
            task_due_date: editedData?.task_due_date || data?.task_data.task_due_date,
            task_content: editedData?.task_content || data?.task_data.task_content,
            task_status: editedData?.task_status || data?.task_data.task_status
        }

     
        callback({action: 'taskUpdate', putData: putData})
    }

  const handleDelete = async () => {
    if (deleteConfirmation === 0) {
      setDeleteConfirmation(1)
      return false;
    }
     try {
     //    ?id=${target.id}
     let apiUrl = `/api/notifications/${data.notification_uuid}?user_type=${user.user_type}&new_notification_status=DELETED`


          let response = await fetch(apiUrl, {
          method: 'PUT', // if deleting comment, PUT, if deleting post, PUT as well
          headers: {
            'Accept': '*/*',
            'Content-Type': 'application/json'
          },
          credentials: 'include', // If you are sending cookies with a cross-origin request, use 'include'
          // body: JSON.stringify({data: data, tags: {PRIMARY: selectedPrimaryTags, SECONDARY: selectedSecondaryTags}, user: user}), // Convert the credentials object to a JSON string
          // body: data
        });

        response = await response.json()
        // console.log('handleDeleteResponse', response)
      if (response.success === true ) {
          console.log("DELETED")
          callback({refreshData: true})
     //    setSuccess({message: 'The notification has been deleted.'})
        router.refresh()
     //    setLoading(false)
      }
      else { 
        setError({message: 'There was a problem deleting this notification.'})
     //    setLoading(false)
      }
      // callback({refreshData: true})

            
        } catch (error) {
          console.log('error', error)
          // setLoading(false)
        }
}

// not used right now 
  const handleRootDelete = async () => {
    if (rootDeleteConfirmation === 0) {
      setRootDeleteConfirmation(1)
      return false;
    }
     try {
     //    ?id=${target.id}
     let apiUrl;
     if (parentComponent === 'THREAD') { // in post thread - deleting comment
      apiUrl = `/api/social/comments/${data.social_post_comment_uuid}?user_type=${user.user_type}`
     }
     else { // in all posts (social) - deleting post
      apiUrl = `/api/social/posts/${data.social_post_uuid}?user_type=${user.user_type}`
     }

          let response = await fetch(apiUrl, {
          method: 'DELETE', // if deleting comment, PUT, if deleting post, PUT as well
          headers: {
            'Accept': '*/*',
            'Content-Type': 'application/json'
          },
          credentials: 'include', // If you are sending cookies with a cross-origin request, use 'include'
          // body: JSON.stringify({data: data, tags: {PRIMARY: selectedPrimaryTags, SECONDARY: selectedSecondaryTags}, user: user}), // Convert the credentials object to a JSON string
          // body: data
        });

        response = await response.json()
        console.log('handleDeleteResponse', response)
      if (response.success === true ) {
        setSuccess({message: 'The post has been deleted.'})
        router.refresh()
     //    setLoading(false)
      }
      else { 
        setError({message: 'There was a problem deleting this post.'})
     //    setLoading(false)
      }
      // callback({refreshData: true})

            
        } catch (error) {
          console.log('error', error)
          // setLoading(false)
        }
}

// not even a thing in this modal
  const handlePostUpvote = async () => {

    if (!user) {
      setError({message: 'Please sign in'})
    }
     try {
     //    ?id=${target.id}
    //  let apiUrl = `/api/social/reactions/${data.social_post_uuid}?user_type=${user.user_type}`
          let apiUrl = `/api/social/reactions?user_type=${user.user_type}`


          let response = await fetch(apiUrl, {
          method: 'POST', // if deleting comment, PUT, if deleting post, PUT as well
          headers: {
            'Accept': '*/*',
            'Content-Type': 'application/json'
          },
          credentials: 'include', // If you are sending cookies with a cross-origin request, use 'include'
          body: JSON.stringify({data: {
            reaction_type: 'UPVOTE', 
            reaction_target_type: data.social_post_uuid ? 'SOCIAL_POST' : 'SOCIAL_COMMENT',
            reaction_target_uuid: data.social_post_uuid ? data.social_post_uuid : data.social_post_comment_uuid
          }, user: user}), // Convert the credentials object to a JSON string
          // body: data
        });

        response = await response.json()
        // console.log('handleUpvoteResponse', response)
      if (response.success === true ) {
        // setSuccess({message: 'The post has been upvoted.'})
        router.refresh()
     //    setLoading(false)
      }
      else { 
        setError({message: `There was a problem upvoting this post. Error: ${response.error.message}`})
     //    setLoading(false)
      }
      // callback({refreshData: true})

            
        } catch (error) {
          console.log('error', error)
          // setLoading(false)
        }
}

// not even a thing in this modal
const handleDeleteUpvote = async () => {
       try {
     //    ?id=${target.id}
     let apiUrl;
     if (parentComponent === 'THREAD') { // in post thread - deleting comment
      apiUrl = `/api/social/reactions/${data.social_post_comment_uuid}?user_type=${user.user_type}&record_type=COMMENT`
     }
     else { // in all posts (social) - deleting post
      apiUrl = `/api/social/reactions/${data.social_post_uuid}?user_type=${user.user_type}&record_type=POST`
     }

          let response = await fetch(apiUrl, {
          method: 'DELETE', // if deleting comment, PUT, if deleting post, PUT as well
          headers: {
            'Accept': '*/*',
            'Content-Type': 'application/json'
          },
          credentials: 'include', // If you are sending cookies with a cross-origin request, use 'include'
          // body: JSON.stringify({data: data, tags: {PRIMARY: selectedPrimaryTags, SECONDARY: selectedSecondaryTags}, user: user}), // Convert the credentials object to a JSON string
          // body: data
        });

        response = await response.json()
        console.log('handleDeleteResponse', response)
      if (response.success === true ) {
        // setSuccess({message: 'The post has been deleted.'})
        router.refresh()
     //    setLoading(false)
      }
      else { 
       setError({message: `There was a problem upvoting this post. Error: ${response.error.message}`})
     //    setLoading(false)
      }
      // callback({refreshData: true})

            
        } catch (error) {
          console.log('error', error)
          // setLoading(false)
        }
}

const handleRespond = async (e) => {
  e.preventDefault()
  if (parentComponent === 'THREAD'){ // in root comment thread, this becomes a reply to a comment
      router.push(`?thread=${searchParams.get('thread')}&reply-to-uuid=${data.social_post_comment_uuid}&reply-to-handle=${data.user_data.user_handle}`, undefined, {shallow:true, scroll:false})
  }
  else if (parentComponent === 'INDEX') { // in all posts, this becomes a root comment to a post (we're attaching social/ to searchParams)
    router.push(`social?thread=${data.social_post_uuid}`, undefined, {shallow:true, scroll:false})
  }
  else { // in all posts, this becomes a root comment to a post
    router.push(`?thread=${data.social_post_uuid}#${data.social_post_uuid}`, undefined, {shallow:true, scroll:false})
    // #data.socialpostuuid prevents page from jumping up here
  }
}



    const handleChange = (field, value) => {
     //    setEditedData({
     //        ...editedData,
     //        [field]: value
     //        // [event.target.name]: event.target.value,
     //    });
     //    console.log(editedData);
    };

// function countComments(comments = []) {
//   let count = 0;

//   for (const comment of comments) {
//     count += 1; // count this comment

//     if (comment.replies && comment.replies.length > 0) {
//       count += countComments(comment.replies); // recurse
//     }
//   }

//   return count;
// }
        function countComments(comments = []) {
            let count = 0;

            for (const comment of comments) {
                count += 1; // count this comment

                if (comment.replies && comment.replies.length > 0) {
                count += countComments(comment.replies); // recurse
                }
            }

            return count;
        }


// console.log("data@SocialPostSmallCard", data)
// console.log("replyToUUID", replyToUUID, data.social_post_comment_uuid, data.social_post_comment_body)



// const messageMap = {
//      // SOCIAL_POST = notification_target_type
//      'SOCIAL_POST': {url: `/feed?thread=${data.notification_target_uuid}`, message: <>Reacted to your post</>},
//      'SOCIAL_COMMENT': {url: `/feed?thread=${data.notification_target_uuid}`, message: <>Commented on your post</>},
//      // 'TALENT_PROFILE': {url: `https://talnet.co/talent/${data.notification_action_url}`, message: <>New talent submission for one of your jobs</>}
//      'TALENT_PROFILE': {url: `/workspace/submissions`, message: <>New talent submission for one of your jobs</>},
//     // 'CONTENT_MODERATION_DECISION'
// }


  return (

 <div id={data.social_post_uuid} className={`${isNestedComment && 'border-l'} ${data.notification_status === 'SEEN' ? 'bg-transparent' : 'bg-slate-100 dark:bg-slate-800'}  dark:hover:bg-slate-800  rounded-lg ${(replyToUUID && replyToUUID === data.social_post_comment_uuid) && 'dark:bg-slate-950 bg-slate-100 border-l-2 border-l-teal-400 dark:border-l-teal-400'} w-full  border-slate-200 dark:border-slate-700 px-4 py-4 transition-all ease-in-out duration-150`}>
      {/* <Alert state={{success: success, setSuccess: setSuccess, error: error, setError: setError}} message={success ? success.message : error ? error.message : ''}/> */}

      {/* Header: Avatar + Name + Timestamp */}
      <div className="grid grid-cols-[auto_minmax(0,1fr)_auto] items-start gap-2">

        {/* avatar - left */}
        <div className="col-span-1">
        <Link href={`/@${data.notification_initiator_user_data?.user_handle}`}>
          <AvatarImage isAnonymous={false} data={data.notification_initiator_user_data} module="USER" size={'xs'} background={false} hoverable={true} />
        </Link> 
        </div>
        
           

        {/* body - center */}
        <div className="col-span-4">
        <div className="flex flex-col w-full">
          <div className="flex items-start gap-2 leading-none">
       
              <div className="flex flex-col gap-1">
                <Link href={`/@${data.notification_initiator_user_data?.user_handle}`}>
                  <span className={`hover:underline cursor-pointer dark:text-white font-ubuntu`}>
                    {data.notification_initiator_user_data?.user_first_name} {data.notification_initiator_user_data?.user_last_name}
                  </span>
                </Link>
                <div className="flex flex-col sm:flex-row gap-1">
                  <Link  href={`/@${data.notification_initiator_user_data?.user_handle}`}>
                  <span className="flex items-center text-xs text-slate-400">@{data.notification_initiator_user_data?.user_handle}</span>
                  </Link>
                  <span className="flex hidden sm:block items-center text-slate-300  text-xs" aria-hidden="true">⋅</span>

                <span className="flex items-center text-xs text-slate-400">
                  {new Date(data.created_date).toLocaleString('en-US', {
                    month: 'short',
                    day: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit',
                    year: 'numeric'
                  })}
                  </span>
                 </div>
              </div>
              {/* <div className="flex flex-col gap-1">
                <Link href={`/@${data.notification_initiator_user_data?.user_handle}`}>
                  <span className={`hover:underline cursor-pointer dark:text-white font-ubuntu`}>
                    {data.notification_initiator_user_data?.user_first_name} {data.notification_initiator_user_data?.user_last_name}
                  </span>
                </Link>
                <div className="flex flex-col sm:flex-row gap-1">
                  <Link  href={`/@${data.notification_initiator_user_data?.user_handle}`}>
                  <span className="flex items-center text-xs text-slate-400">@{data.notification_initiator_user_data?.user_handle}</span>
                  </Link>
                  <span className="flex hidden sm:block items-center text-slate-300  text-xs" aria-hidden="true">⋅</span>
                <span className="flex items-center text-xs text-slate-400">
                  {new Date(data.created_date).toLocaleString('en-US', {
                    month: 'short',
                    day: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit',
                    year: 'numeric'
                  })}
                  </span>
                 </div>
              </div> */}
            
            

           
          </div>
          
          {/* Post body */}

          {/* {messageMap[data.notification_target_type]?.message && 
          <div className="font-inter font-normal mt-2">
              { messageMap[data.notification_target_type]?.message}
            </div>
            } */}
          {/* {data.notification_message && 
          <div className="mt-1 text-sm text-slate-800 dark:text-gray-300 whitespace-pre-wrap">
            <div className="font-inter font-normal mt-2">
                         {formatSocialPostBody(data.notification_title)}
            </div>
            {formatSocialPostBody(data.notification_message)}
          </div>} */}
        

         







  <div className="mt-2 flex gap-2 text-xs text-slate-500 dark:text-slate-400">

     {/* {
     user?.user_is_root && 
    <div className="flex gap-1 items-center">
      <TrashButton disabled={false} onClick={handleRootDelete} deleteConfirmation={rootDeleteConfirmation}/>
      <div>|</div>
    </div>
    } */}
    


{
  /* -------------------------------
    if user is root 
    AND 
    if post doesn't belong to user AND location is not post thread
    AND
    post / comment is not deleted
  ---------------------------------*/


//   1==1
//   && (
//   <>
//   {
//     (user?.user_uuid === data.job_user_uuid || user?.user_uuid === data.talent_user_uuid) 
//       &&
//       <TrashButton disabled={data.is_archived} onClick={handleDelete} deleteConfirmation={deleteConfirmation}/>
//   }
//    <CommentButton disabled={false} onClick={handleRespond} caption={data.comments_count || data.replies?.length || 0}/>
//    <ArrowUpButton disabled={data.is_archived} onClick={data.reacted_by_me ? handleDeleteUpvote : handlePostUpvote} caption={data.reactions_count} reacted={data.reacted_by_me}/>
//    </>)

}
    </div>     
      
        </div>
        </div>


        {/* action buttons - right */}
        <div className="col-span-1">

          <div className="flex gap-1 items-center h-full">
      <TrashButton disabled={false} onClick={handleDelete} deleteConfirmation={deleteConfirmation}/>
      {data.notification_action_url && <OpenUrlButton onClick={()=>setNotificationsModalOpen(false)} disabled={false} url={ data.notification_action_url}/>}
    {/* <ArrowUpButton disabled={data.is_archived} onClick={handlePostUpvote} caption={data.reactions_count} reacted={data.reacted_by_me}/> */}
    </div>
        </div>

        <div className="col-span-6">
          {data.notification_message && 
          <div className="mt-1 text-sm text-slate-800 dark:text-gray-300 whitespace-pre-wrap">
            <div className="font-inter font-normal mt-2">
                         {formatSocialPostBody(data.notification_title)}
            </div>
            {formatSocialPostBody(data.notification_message)}
          </div>}
      </div>
      </div>


    </div>



  )
};

export default NotificationSmallCard;
